import type { Card } from "./types.js";

/** Gradient and emoji fallbacks so a card always renders, even with no media file. */
export const paletteFor = (c: Card): [string, string, string] => {
  if (c.u.cul >= 0.7) return ["#3A0F0F", "#8E1F1F", "#E4572E"];
  if (c.u.nig >= 0.7) return ["#141A26", "#3E2E6E", "#FF6B9D"];
  if (c.u.adv >= 0.7) return ["#16202E", "#31506E", "#8FB7D9"];
  if (c.ax.terrain <= -0.5) return ["#1F2E2A", "#3F6E5E", "#BFD9A8"];
  if (c.ax.era <= -0.6) return ["#4A1F1F", "#9E3B34", "#8A8FA8"];
  if (c.ax.terrain >= 0.5) return ["#10131F", "#2E3A6E", "#E0B14F"];
  return ["#22302E", "#4A6E66", "#BFD9CC"];
};
export const emojiFor = (c: Card): string => {
  if (c.u.cul >= 0.8) return "🍜";
  if (c.u.adv >= 0.8) return "🧗";
  if (c.u.nig >= 0.8) return "🌃";
  if (c.ax.terrain <= -0.6) return "⛰️";
  if (c.ax.era <= -0.7) return "🏯";
  if (c.ax.terrain >= 0.6) return "🌆";
  return "📍";
};
